var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 160 160"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M114.61 61.19V34.75C114.61 15.56 99.06 0 79.87 0S45.13 15.56 45.13 34.74v26.65c-12.56 10.17-20.6 25.71-20.6 43.13 0 30.64 24.84 55.48 55.48 55.48s55.48-24.84 55.48-55.48c0-17.54-8.15-33.17-20.86-43.34ZM55.6 34.75c0-13.38 10.89-24.27 24.27-24.27s24.27 10.89 24.27 24.27v19.82c-7.3-3.53-15.48-5.51-24.14-5.51s-17.03 2.04-24.4 5.65V34.76Zm31.44 78.73v11.36c0 3.89-3.15 7.04-7.04 7.04s-7.04-3.15-7.04-7.04v-11.36c-6.06-2.7-10.29-8.76-10.29-15.83 0-9.57 7.76-17.33 17.33-17.33s17.33 7.76 17.33 17.33c0 7.06-4.23 13.13-10.29 15.83Z"
})));

export default SvgLock;